// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6k-4";
export var collapsed = "_6k-1";
export var headerBar = "_6k-0";
export var leftHeaderContent = "_6k-3";
export var subjectContainer = "_6k-2";